import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as Exclamation } from '../../assets/icons/exclamation-icon.svg';
import { ModalSto } from '../sto';

const AccountExistsModal = (props) => (
    <ModalSto
        buttonSize="large"
        modalType="accountExists"
        okText="pages.registration.step1.accountexists.ok"
        onOk={props.onOk}
        visible={props.visible}
        wrapClassName="account-exists-modal"
    >
        <React.Fragment>
            <div className="account-exists-modal" role="alert">
                <div className="exclamation-icon">
                    <Exclamation />
                </div>
                <p>
                    <FormattedMessage id="pages.registration.step1.accountexists" />
                </p>
            </div>
        </React.Fragment>
    </ModalSto>
);

export default AccountExistsModal;
